import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Table from "./pages/Table/index";
import GlobalActions from "./pages/Panel/GlobalActions";
import Overview from "./pages/Panel/Overview";
import Form from "./pages/Form/Form";
import Login from "./pages/Login";
import Redirect from "./pages/Redirect/Redirect";
import Sidebar from "./pages/SideBar/Sidebar";
import Main from "./pages/Main";
import Invoice from "./pages/Invoice/Invoice";
import SendMailInv from "./pages/Invoice/SendMailInv";
import StudentInv from "./pages/Invoice/StudentInv";
import Auditing from "./pages/Auditing/Auditing";
import StudentAud from "./pages/Auditing/StudentAud";
import Edit from "./pages/Edit";
import AddUser from "./pages/AddUser/AddUser";
import SendMailAud from "./pages/Auditing/SendMailAud";
import ScoreHandler from "./pages/ScoreHandler/ScoreHandler";
import StudentScore from "./pages/ScoreHandler/StudentScore";
import Print from "./pages/Print/Print";
import StudentPrint from "./pages/Print/StudentPrint";
import Moe from "./pages/Moe/Moe";
import StudentMoe from "./pages/Moe/StudentMoe";
import Deliver from "./pages/Deliver/Deliver";
import StudentDeliver from "./pages/Deliver/StudentDeliver";
import Done from "./pages/Done/Done";
import StudentDone from "./pages/Done/StudentDone";
import ScoreComment from "./pages/ScoreHandler/ScoreComment";
import MoeComment from "./pages/Moe/MoeComment";
import MOHE from "./pages/MOHE/MOHE";
import StudentMOHE from "./pages/MOHE/StudentMOHE";
import AudPend from "./pages/Auditing/AudPend";
import TransferForm from "./pages/Transfer/TransferForm";
import TransferSuccess from "./pages/Transfer/TransferSuccess";
import TransferError from "./pages/Transfer/TransferError";
import TransferSubmissions from "./pages/Transfer/TransferSubmissions";
import Schools from "./pages/Schools/Schools";
import UploadEnrollmentLetters from "./pages/EnrollmentLetters/UploadEnrollmentLetters";
import QrCodes from "./pages/QrCodes/QrCodes";
import TopAchieversGuests from "./pages/TopAchieversGuests/TopAchieversGuests";
import AllTopAchievers from "./pages/AllTopAchievers/AllTopAchievers";
import Efada from "./pages/Efada/Efada";
import EfadaHistory from "./pages/Efada/EfadaHistory";
import RushStudents from "./pages/RushStudents/RushStudents";
import SendScoreForm from "./pages/SendScore/SendScoreForm";
import SendScoreSubmissions from "./pages/SendScore/SendScoreSubmissions";

function App() {
  return (
    <Routes>
      <Route path="/form/*" element={<Form />} />
      <Route path="/send-score" element={<SendScoreForm />} />
      <Route path="/transfer" element={<TransferForm />} />
      <Route path="/transfer/success" element={<TransferSuccess />} />
      <Route path="/transfer/error" element={<TransferError />} />
      <Route path="/redirect" element={<Redirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/main" element={<Sidebar />}>
        <Route path="" element={<Main />} />
        {/* start admin routes */}
        <Route path="overview" element={<Overview />} />
        <Route path="table" element={<Table />} />
        <Route path="actions" element={<GlobalActions />} />
        <Route path="add_user" element={<AddUser />} />
        {/* end admin routes */}
        {/* start auditing routes */}
        <Route path="auditing/new" element={<Auditing />} />
        <Route path="auditing/new/:id" element={<StudentAud />} />
        <Route path="auditing/new/edit" element={<Edit />} />
        <Route path="auditing/request_edit" element={<Auditing />} />
        <Route path="auditing/request_edit/:id" element={<StudentAud />} />
        <Route path="auditing/request_edit/edit" element={<Edit />} />
        <Route path="auditing/request_edit/mail" element={<SendMailAud />} />
        <Route path="auditing/pending" element={<AudPend />} />
        <Route path="auditing/pending/:id" element={<StudentAud />} />
        {/* end auditing routes */}
        {/* start invoice routes */}
        <Route path="invoice/new" element={<Invoice />} />
        <Route path="invoice/another_invoice" element={<Invoice />} />
        <Route path="invoice/wait" element={<Invoice />} />
        <Route path="invoice/new/:id" element={<StudentInv />} />
        <Route path="invoice/another_invoice/:id" element={<StudentInv />} />
        <Route path="invoice/wait/:id" element={<StudentInv />} />
        <Route path="invoice/new/mail" element={<SendMailInv />} />
        {/* end invoice routes */}
        {/* start score request routes */}
        <Route path="score/score_validation" element={<ScoreHandler />} />
        <Route path="score/new" element={<ScoreHandler />} />
        <Route path="score/score_pending" element={<ScoreHandler />} />
        <Route path="score/score_validation/:id" element={<StudentScore />} />
        <Route path="score/new/:id" element={<StudentScore />} />
        <Route path="score/score_pending/:id" element={<StudentScore />} />
        <Route path="score/score_pending/comment" element={<ScoreComment />} />
        {/* end score request routes */}
        {/* start print routes */}
        <Route path="print/new" element={<Print />} />
        <Route path="print/print_validation" element={<Print />} />
        <Route path="print/print_validation/:id" element={<StudentPrint />} />
        <Route path="print/new/:id" element={<StudentPrint />} />
        {/* end print routes */}
        {/* start moe routes */}
        <Route path="moe/moe_validation" element={<Moe />} />
        <Route path="moe/new" element={<Moe />} />
        <Route path="moe/moe_pending" element={<Moe />} />
        <Route path="moe/moe_hold" element={<Moe />} />
        <Route path="moe/aatc_review" element={<Moe />} />
        <Route path="moe/moe_validation/:id" element={<StudentMoe />} />
        <Route path="moe/new/:id" element={<StudentMoe />} />
        <Route path="moe/moe_pending/:id" element={<StudentMoe />} />
        <Route path="moe/moe_hold/:id" element={<StudentMoe />} />
        <Route path="moe/aatc_review/:id" element={<StudentMoe />} />
        <Route path="moe/moe_pending/comment" element={<MoeComment />} />
        {/* end moe routes */}
        {/* start deliver routes */}
        <Route path="deliver/deliver_onsite" element={<Deliver />} />
        <Route path="deliver/aramex" element={<Deliver />} />
        <Route path="deliver/delivery_hold" element={<Deliver />} />
        <Route path="deliver/deliver_onsite/:id" element={<StudentDeliver />} />
        <Route path="deliver/aramex/:id" element={<StudentDeliver />} />
        <Route path="deliver/delivery_hold/:id" element={<StudentDeliver />} />
        {/* end deliver routes */}
        {/* start Final routes */}
        <Route path="mohe/mohe_validation" element={<MOHE />} />
        <Route path="mohe/new" element={<MOHE />} />
        <Route path="mohe/mohe_validation/:id" element={<StudentMOHE />} />
        <Route path="mohe/new/:id" element={<StudentMOHE />} />
        <Route path="done" element={<Done />} />
        <Route path="done/:id" element={<StudentDone />} />
        {/* end done routes */}
        {/* transfer routes */}
        <Route path="transfer/submissions" element={<TransferSubmissions />} />
        {/* schools management */}
        <Route path="schools" element={<Schools />} />
        {/* enrollment letters */}
        <Route path="enrollment_letters" element={<UploadEnrollmentLetters />} />
        {/* send score submissions (approver view) */}
        <Route path="send_score_submissions" element={<SendScoreSubmissions />} />
        {/* QR codes */}
        <Route path="qrcodes" element={<QrCodes />} />
        {/* top achievers guests — open to every role */}
        <Route path="top_achievers_guests" element={<TopAchieversGuests />} />
        {/* all top achievers (ACT1 + ACT2), filterable by date/grade/city/event location */}
        <Route path="all_top_achievers" element={<AllTopAchievers />} />
        {/* Efada (الافادة) letter — pick a student's ACT grades, download as Word */}
        <Route path="efada" element={<Efada />} />
        {/* Every generated Efada letter — admin / asmaa / abdelrhman only */}
        <Route path="efada_history" element={<EfadaHistory />} />
        {/* rush students — National ID/Name/Phone/State/Authentication Date + Delivered status */}
        <Route path="rush_students" element={<RushStudents />} />
      </Route>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="*" element={<Navigate to="/form" />} />
    </Routes>
  );
}

export default App;
